<template>
  <v-tabs color="primary" slider-color="blue-darken-3">
    <v-tab :to="{ name: `document-review-preview` }" replace> Документ </v-tab>
    <v-tab :to="{ name: `document-review-resolutions` }" replace>
      Резолюції
    </v-tab>
  </v-tabs>
</template>

<script setup lang="ts">
defineOptions({
  name: 'DocumentTabs',
})
</script>
